import { createElement } from 'react';
import { Separator as Separator$1 } from '@radix-ui/react-dropdown-menu';

const Separator = () => {
  return createElement(Separator$1, {
    className: "bg-grey-dark my-1 h-px"
  });
};

export { Separator };
//# sourceMappingURL=Separator.js.map
